import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import TableContent from "../TableContent";

export default function FreeToSell() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await axios.get("/api/freetosell");
      setData(res.data);
      setIsLoading(false);
    })();
  }, []);

  const defaultNumberSort = useMemo(
    () => (rowA, rowB, columnId) =>
      Number(rowA.values[columnId]) >= Number(rowB.values[columnId]) ? 1 : -1
  );

  const columns = useMemo(
    () => [
      {
        Header: "해제일",
        columns: [
          { accessor: "return_date", Header: "", disableFilters: true },
        ],
      },
      {
        Header: "회사명",
        columns: [
          {
            accessor: "name",
            Header: "",
            disableSortBy: true,
          },
        ],
      },
      {
        Header: "거래시장",
        columns: [
          { accessor: "market", Header: "", disableSortBy: true },
        ],
      },

      {
        Header: "해제주식수",
        columns: [
          {
            accessor: "return_qty",
            Header: "",
            disableFilters: true,
            Cell: ({ value }) => {
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            sortType: defaultNumberSort,
          },
        ],
      },
      {
        Header: "총주식수",
        columns: [
          {
            accessor: "total_qty",
            Header: "",
            disableFilters: true,
            Cell: ({ value }) => {
              return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            sortType: defaultNumberSort,
          },
        ],
      },
      {
        Header: "사유",
        columns: [
          { accessor: "reason", Header: "", disableSortBy: true },
        ],
      },
    ],
    []
  );

  return (
    <TableContent
      isLoading={isLoading}
      columns={columns}
      data={data}
      needChart={false}
      useUniformWidth={true}
    />
  );
}
